import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import CompanyList from './CompanyList';

const CompanyListPage = () => {
    const { t } = useTranslation('companyList');

    const goToNewCompanyPage = useGoTo('/admin/companies/add');
    const { permissions: accountPermissions } = useAccount();

    const extra = hasPermissions(accountPermissions, [permissionKind.createCompany]) ? (
        <Button icon={<PlusOutlined />} onClick={goToNewCompanyPage} type="primary">
            {t('companyList:actions.newCompany')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('companyList:title')}>
            <CompanyList />
        </ConsolePageWithHeader>
    );
};

export default CompanyListPage;
